export function getHoursAndMinutes(value: any, type: 'h' | 's' = 'h') {
  let seconds;

  if (type === 's') {
    seconds = Number(value);
  } else {
    seconds = Number(value) * 60;
  }

  let hours: number = Math.floor(seconds / 3600),
    minutes: number = Math.round((seconds - hours * 3600) / 60);

  if (minutes === 60) {
    hours += 1;
    minutes = 0;
  }

  return {
    h: hours,
    m: minutes
  };
}
